import { render, staticRenderFns } from "./NotExportedToPigult.vue?vue&type=template&id=90e879e8&"
import script from "./NotExportedToPigult.vue?vue&type=script&lang=js&"
export * from "./NotExportedToPigult.vue?vue&type=script&lang=js&"
import style0 from "./NotExportedToPigult.vue?vue&type=style&index=0&id=90e879e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports